<template>
  <div class="page sign-page" :class="{ 'force-rotate': isPortrait }">
    <div class="content">
      <div>请用正楷在下框写入您的真实姓名：</div>
      <div class="sign-wrap" id="signWrap">
        <canvas id="myCanvas"></canvas>
      </div>
    </div>
    <div class="fix-btn">
      <el-button size="large" type="hollow" class="hollow-primary-btn" @click.native="clearArea()">清除</el-button>
      <el-button size="large" type="primary" @click.native="saveSign()">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: "",
      mousePressed: false,
      c: null,
      ctx: null,
      lastX: 0,
      lastY: 0,
      isMtou: false,
      isPortrait: true,
    };
  },
  mounted() {
    this.checkOrientation();
    window.addEventListener("resize", this.handleResize);
    this.initCanvas();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    checkOrientation() {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      this.isPortrait = width < height;
    },

    handleResize() {
      this.checkOrientation();
      setTimeout(() => {
        this.initCanvas(); 
      }, 200);
    },

    initCanvas() {
      this.image = "";
      this.mousePressed = false;
      this.c = document.getElementById("myCanvas");
      this.ctx = this.c.getContext("2d");
      
      var signWrap = document.getElementById("signWrap");
      this.c.width = signWrap.clientWidth; 
      this.c.height = signWrap.clientHeight; 
      
      // 【修改点1】不再填充白色背景，保持 Canvas 透明
      // CSS 会让它看起来是白色的，但导出的图片背景将是透明的
      this.ctx.clearRect(0, 0, this.c.width, this.c.height);
      
      if (!this.hasInitEvents) {
          this.InitThis();
          this.hasInitEvents = true;
      }
    },

    getCanvasPos(event) {
      const rect = this.c.getBoundingClientRect();
      let clientX, clientY;

      if (event.changedTouches && event.changedTouches.length > 0) {
        clientX = event.changedTouches[0].clientX;
        clientY = event.changedTouches[0].clientY;
      } else {
        clientX = event.clientX;
        clientY = event.clientY;
      }

      const scaleX = this.c.width / rect.width;
      const scaleY = this.c.height / rect.height;
      
      let x, y;

      if (this.isPortrait) {
        const realScaleX = this.c.width / rect.height; 
        const realScaleY = this.c.height / rect.width; 
        x = (clientY - rect.top) * realScaleX;
        y = (rect.right - clientX) * realScaleY;
      } else {
        x = (clientX - rect.left) * scaleX;
        y = (clientY - rect.top) * scaleY;
      }
      return { x, y };
    },

    InitThis() {
      var that = this;
      // ... 保持原有事件监听逻辑不变 ...
      // 为节省篇幅，此处省略重复的 addEventListener 代码，逻辑与上一个版本完全一致
      const start = (e) => {
          e.preventDefault();
          const pos = that.getCanvasPos(e);
          that.mousePressed = true;
          that.Draw(pos.x, pos.y, false);
      };
      const move = (e) => {
          e.preventDefault();
          if (that.mousePressed) {
            const pos = that.getCanvasPos(e);
            that.Draw(pos.x, pos.y, true);
          }
      };
      const end = (e) => {
          e.preventDefault();
          that.mousePressed = false;
      };

      this.c.addEventListener("touchstart", (e)=>{if(e.targetTouches.length==1) start(e)}, false);
      this.c.addEventListener("touchmove", (e)=>{if(e.targetTouches.length==1) move(e)}, false);
      this.c.addEventListener("touchend", (e)=>{if(e.targetTouches.length==1) end(e)}, false);
      
      this.c.onmousedown = start;
      this.c.onmousemove = move;
      this.c.onmouseup = end;
      this.c.onmouseleave = end;
    },

    Draw(x, y, isDown) {
      if (isDown) {
        this.ctx.beginPath();
        this.ctx.strokeStyle = "#000"; 
        this.ctx.lineWidth = 3; 
        this.ctx.lineJoin = "round";
        this.ctx.lineCap = "round";
        this.ctx.moveTo(this.lastX, this.lastY);
        this.ctx.lineTo(x, y);
        this.ctx.closePath();
        this.ctx.stroke();
        this.isMtou = true;
      }
      this.lastX = x;
      this.lastY = y;
    },

    clearArea() {
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      // 【修改点2】清空时不填充白色，保持透明
      this.isMtou = false;
    },

    saveSign() {
      this.checkEmpty();
    },

    async checkEmpty() {
      if (this.isCanvasBlank(this.c)) {
        alert('请签名！');
        return;
      } else {
        // 【修改点3】使用裁剪函数获取裁剪后的透明 Base64 图片
        var image = this.cropSignature();
        
        console.log("生成的精简图片大小:", image.length);
        
        this.$http.post('/student/pc/studentStatus/sign/submit', { 
          ...this.$route.query, 
          sign: image 
        }).then(async(res) => {
          await alert('操作成功');
          this.closePage();
        }).catch(() => {
           // alert('提交失败');
        });
      }
    },

    /**
     * 【新增方法】裁剪签名区域并保留透明背景
     * 算法原理：扫描像素点，找到上下左右的边界，然后截取
     */
    cropSignature() {
      const canvas = this.c;
      const ctx = this.ctx;
      const w = canvas.width;
      const h = canvas.height;
      
      // 获取所有像素数据
      const imgData = ctx.getImageData(0, 0, w, h);
      const data = imgData.data;
      
      let minX = w, minY = h, maxX = 0, maxY = 0;
      let found = false;

      // 扫描所有像素，找到非透明像素的边界
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          // data中每4个数组元素代表一个像素：R, G, B, Alpha
          // 我们只需要检查 Alpha (透明度) 是否大于0
          const alpha = data[(y * w + x) * 4 + 3];
          
          if (alpha > 0) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
            found = true;
          }
        }
      }

      // 如果全是透明的（没签名），直接返回原图（或处理为空）
      if (!found) return canvas.toDataURL("image/png");

      // 添加一点边距 padding
      const padding = 10;
      minX = Math.max(0, minX - padding);
      minY = Math.max(0, minY - padding);
      maxX = Math.min(w, maxX + padding);
      maxY = Math.min(h, maxY + padding);

      const cropWidth = maxX - minX;
      const cropHeight = maxY - minY;

      // 创建一个临时的 Canvas 用于裁剪
      const cropCanvas = document.createElement('canvas');
      cropCanvas.width = cropWidth;
      cropCanvas.height = cropHeight;
      const cropCtx = cropCanvas.getContext('2d');

      // 将原图的有效区域绘制到临时 Canvas 上
      cropCtx.drawImage(canvas, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

      // 生成 Base64 (PNG 格式支持透明)
      return cropCanvas.toDataURL("image/png");
    },

    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/micromessenger/i) == 'micromessenger';
    },

    closePageWx() {
      if (!this.isWechat()) return;
      setTimeout(function () {
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          WeixinJSBridge.invoke('closeWindow', {}, function (res) {});
        }
      }, 100);
    },

    closePage() {
      if ((navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) && !this.isWechat()) {
        window.location.href = 'about:blank';
        window.close();
      } else if (this.isWechat()) {
        this.closePageWx();
      } else {
        window.opener = null;
        window.open('', '_self');
        window.close();
      }
    },

    isCanvasBlank(canvas) {
      return !this.isMtou;
    },
  }
};
</script>

<style scoped>
.page {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background-color: #f0f2f5; /* 页面背景色，这里设为灰色，方便看出 Canvas 是白色的 */
}

/* 竖屏强制旋转 */
.page.force-rotate {
  transform: rotate(90deg) translateY(-100%);
  transform-origin: top left;
  width: 100vh;
  height: 100vw;
}

.hollow-primary-btn {
  color: #228ade;
  border-color: #228ade;
}

.sign-page .content {
  padding: 0.3rem;
  font-size: 14px;
  height: calc(100% - 70px);
  color: #333;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.sign-wrap {
  margin-top: 0.3rem;
  width: 100%;
  flex: 1; 
  border: 1px dashed #999;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff; /* 这里设置 Canvas 容器背景为白色，给用户“白纸”的视觉 */
}

#myCanvas {
  /* Canvas 元素背景透明，但因为父级 .sign-wrap 是白色的，所以用户看起来是白色的 */
  display: block; 
}

.fix-btn {
  position: absolute; 
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
  z-index: 10;
}
</style>